<template>
  <div class="min-h-dvh flex flex-col"> <!-- plus de pb-28 -->
    <app-menu></app-menu>
    <slot></slot>
    <bottom-menu></bottom-menu>
  </div>
</template>
<script>



import AppMenu from './common/Menu.vue'
import moment from "moment/moment";
import Operateur from "../js/models/Operateur";
import User from "../js/models/User";
import BottomMenu from './common/BottomMenu.vue';

export default {
  data() {
    return {

    }
  },
  components: {
    AppMenu,
    BottomMenu
  },
  mounted() {
      this.loadRemoteScript();
      const inputDateElements = document.querySelectorAll('input[type="date"][max]');

      inputDateElements.forEach(function(input) {
          input.addEventListener('change', function() {

              let maxDate = new Date(this.getAttribute('max'));
              let selectedDate = new Date(this.value);


              if (selectedDate > maxDate) {
                  this.setCustomValidity("La date ne peut pas être dans le futur.");
                  this.value = moment(maxDate).format('YYYY-MM-DD');

                  // Déclenche un événement 'input' pour mettre à jour l'affichage visuel
                  const inputEvent = new Event('input', { bubbles: true });
                  this.dispatchEvent(inputEvent);
              } else {
                  this.setCustomValidity("");
              }

              this.reportValidity();
          })
      })
  },
  methods: {
      async loadRemoteScript() {
          return;
          /*
          try {
              User.getUserData(function (user) {
                  const script = document.createElement('script');
                  script.setAttribute('data-consolejs-channel', 'mobiledev-31599430-5abe-fi360-4d74-df1f-061994b2b42b-' + user.id);
                  script.src = 'https://remotejs.com/agent/agent.js';
                  script.async = true;
                  document.body.appendChild(script);
                  console.log('remoteJS charged - user : (' + user.id + ') ' + user.last_name + ' ' + user.first_name + ' Operateur : (' + user.operator.id + ') ' + user.operator.company);
                  localStorage.setItem('remotejs', 'mobiledev-31599430-5abe-fi360-4d74-df1f-061994b2b42b-' + user.id);
              })
          } catch (error) {
              console.error('Erreur lors du chargement du script distant :', error);
          }
           */
      },
  }
}

</script>

<style scoped>

.container {
  background-color: #fbfafa;
  font-size: 1.6rem;
  line-height: 1.4;
  font-family: "Open Sans";
  color: #333;

  margin: 0 auto;
  padding: 0;
  width: 100%;
  max-width: 600px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// Layout.vue?7b2588a4